import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneairportcab() {



  const cardData = {
"keyword": "Pune Airport Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Airport Cab Service for hassle-free airport transfers to and from Pune International Airport. Whether you are traveling for business, leisure, or family trips, our airport taxi service ensures timely pickups, smooth drop-offs, and a stress-free travel experience. With professional drivers, well-maintained air-conditioned cars, and transparent pricing with no hidden charges, we guarantee safe and punctual airport transportation. Our fleet includes sedans, SUVs, and premium vehicles suitable for solo travelers, families, and corporate clients. Shivai Travels provides 24/7 airport cab availability, easy online booking, and dependable service for both domestic and international flight transfers in Pune.",

"topPlaces": [
  {
    "title": "Pune Airport Pickup Service",
    "description": "Pune Airport cab service offers reliable pickup from Pune Airport with timely arrival, professional drivers, and comfortable vehicles for smooth onward travel to any location in the city."
  },
  {
    "title": "Pune Airport Drop Service",
    "description": "Airport drop cab service in Pune ensures on-time departure from hotels, homes, and offices to Pune Airport with stress-free and punctual travel experience."
  },
  {
    "title": "24/7 Pune Airport Taxi Service",
    "description": "Round-the-clock Pune Airport cab service is available for early morning flights and late-night arrivals, ensuring uninterrupted transportation support at any hour."
  },
  {
    "title": "Affordable Pune Airport Cabs",
    "description": "Budget-friendly airport cab service in Pune provides economical travel options for passengers looking for reliable and cost-effective airport transfers."
  },
  {
    "title": "Pune Airport to City Taxi",
    "description": "Convenient airport to city cab service in Pune connects travelers to major areas like Shivaji Nagar, Kothrud, Hinjewadi, and Viman Nagar with ease."
  },
  {
    "title": "Pune Airport to Outstation Cab",
    "description": "Outstation cab service from Pune Airport offers direct travel to destinations like Mumbai, Nashik, Shirdi, and Mahabaleshwar with comfortable long-distance rides."
  },
  {
    "title": "Corporate Airport Transfer Pune",
    "description": "Professional airport cab service in Pune includes corporate travel solutions for business executives with punctual pickups and premium vehicles."
  },
  {
    "title": "Family Airport Cab Pune",
    "description": "Spacious airport cab options in Pune like Innova and Ertiga are available for families, ensuring safe and comfortable airport transfers."
  },
  {
    "title": "Luxury Airport Cab Pune",
    "description": "Premium airport taxi service in Pune offers luxury vehicles for VIP travelers, weddings, and special occasions with high-end comfort and service."
  },
  {
    "title": "Pre-Booked Pune Airport Taxi",
    "description": "Pre-booked airport cab service in Pune ensures guaranteed pickup, fixed pricing, and hassle-free travel without waiting time at the airport."
  }
],



services: [
  {
    name: "Pune Airport Cab",
    description: "Pune airport cab service provides reliable transportation for passengers traveling to and from Pune Airport terminals. Comfortable vehicles with experienced drivers ensure smooth airport travel for business travelers, tourists, and families. Pickup services are available from homes, offices, hotels, railway stations, and nearby locations across Pune. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for airport transportation needs. Flexible booking options allow convenient airport cab reservations anytime."
  },
  {
    name: "Airport Taxi Pune",
    description: "Airport taxi Pune service offers dependable transportation for domestic and international travelers requiring airport pickup and drop services. Comfortable vehicles provide spacious seating and luggage capacity suitable for airport journeys. Professional chauffeurs ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from residential areas, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Pune Airport Pickup Drop",
    description: "Pune airport pickup drop service provides smooth transportation for passengers traveling between Pune Airport and various city locations. Vehicles ensure comfortable airport travel with sufficient luggage space and reliable travel experience. Professional drivers ensure timely pickup and safe transportation services for travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport pickup and drop reservations."
  },
  {
    name: "Cab to Pune Airport",
    description: "Cab to Pune airport service offers reliable transportation for passengers traveling from Pune city to airport terminals. Comfortable vehicles ensure smooth city travel suitable for business travelers, tourists, and family airport transfers. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and nearby areas across Pune. Flexible booking options allow convenient airport drop reservations."
  },
  {
    name: "Cab from Pune Airport",
    description: "Cab from Pune airport service provides dependable transportation for travelers arriving at Pune Airport and traveling to city or outstation destinations. Comfortable vehicles offer spacious seating and luggage capacity suitable for airport travel requirements. Professional chauffeurs ensure safe driving and timely pickup services from airport terminals. Pickup services are available for hotels, offices, residential areas, railway stations, and nearby destinations across Pune. Flexible booking options allow convenient airport pickup reservations."
  },
  {
    name: "Pune Airport Taxi Booking",
    description: "Pune airport taxi booking service allows passengers to reserve comfortable airport transportation in advance or instantly. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for airport transfers and luggage transportation. Professional drivers ensure punctual pickup and reliable travel experience for passengers. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Airport Transfer Pune",
    description: "Airport transfer Pune service provides reliable transportation between Pune Airport and city or outstation destinations. Comfortable vehicles ensure smooth travel experience suitable for corporate travelers, tourists, and families. Professional drivers ensure safe driving and punctual airport pickup-drop services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport transfer reservations."
  },
  {
    name: "24x7 Airport Cab Pune",
    description: "24x7 airport cab Pune service offers round-the-clock airport transportation for passengers traveling at any time of day or night. Comfortable vehicles ensure reliable airport travel with professional drivers maintaining punctual pickup schedules. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for early morning flights, late-night arrivals, business travel, and emergency airport transportation. Flexible booking options allow convenient airport cab reservations anytime."
  },
  {
    name: "Cheap Airport Cab Pune",
    description: "Cheap airport cab Pune service provides affordable airport transportation for passengers looking for economical travel options. Comfortable vehicles ensure reliable airport travel while maintaining budget-friendly pricing for travelers. Professional drivers ensure safe journeys and punctual pickup services throughout Pune. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient and low-cost airport cab reservations."
  },
  {
    name: "Luxury Airport Cab Pune",
    description: "Luxury airport cab Pune service provides premium airport transportation with high-end vehicles and professional chauffeurs. Luxury vehicles offer spacious interiors, smooth ride quality, and comfortable travel suitable for executives, VIP guests, and family airport transfers. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient luxury airport cab reservations."
  },
  {
    name: "Pune Airport Shuttle Taxi",
    description: "Pune airport shuttle taxi service offers dependable transportation between Pune Airport and nearby city destinations. Comfortable vehicles provide smooth travel experience with spacious seating and luggage space suitable for airport passengers. Professional drivers ensure timely airport pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport shuttle reservations."
  },
  {
    name: "Reliable Airport Taxi Pune",
    description: "Reliable airport taxi Pune service provides trusted airport transportation with experienced drivers and comfortable vehicles. Vehicles ensure smooth city travel and safe airport transfers suitable for business travelers, tourists, and families. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport taxi reservations."
  },
  {
    name: "Private Airport Cab Pune",
    description: "Private airport cab Pune service offers exclusive airport transportation for passengers seeking personalized and comfortable travel experience. Vehicles provide privacy, spacious seating, and smooth airport travel suitable for families, tourists, and executives. Professional drivers ensure safe driving and punctual pickup services throughout Pune. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient private airport cab reservations."
  },
  {
    name: "Pune Airport Cab Fare",
    description: "Pune airport cab fare service provides transparent pricing information for passengers planning airport pickup and drop transportation. Travelers can estimate transportation costs based on vehicle type, distance, and travel requirements. Comfortable vehicles ensure reliable airport travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient fare estimation and airport cab reservations."
  },
  {
    name: "Sedan Airport Cab Pune",
    description: "Sedan airport cab Pune service offers comfortable and economical airport transportation for solo travelers, couples, and small families. Sedan vehicles provide smooth city travel with spacious seating and luggage capacity suitable for airport journeys. Professional drivers ensure punctual pickup and safe driving services across Pune. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient sedan airport cab reservations."
  },
  {
    name: "Pune Airport Pickup and Drop",
    description: "Pune airport pickup and drop service provides convenient transportation for passengers traveling between Pune Airport and city or outstation destinations. Comfortable vehicles ensure smooth airport travel with professional drivers maintaining punctual pickup schedules and safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for business travel, tourism, and family airport transportation. Flexible booking options allow convenient airport transfer reservations."
  }
],

tableData: [
  ["Pune Airport Cab", "Airport Taxi Pune"],
  ["Pune Airport Pickup Drop", "Cab to Pune Airport"],
  ["Cab from Pune Airport", "Pune Airport Taxi Booking"],
  ["Airport Transfer Pune", "24x7 Airport Cab Pune"],
  ["Cheap Airport Cab Pune", "Luxury Airport Cab Pune"],
  ["Pune Airport Shuttle Taxi", "Reliable Airport Taxi Pune"],
  ["Private Airport Cab Pune", "Pune Airport Cab Fare"],
  ["Sedan Airport Cab Pune", "Pune Airport Pickup and Drop"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Airport Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Airport cab service for timely airport pickup and drop transportation. Our professional drivers ensure smooth travel to and from Pune Airport for business and leisure travelers."
      },
      {
        WhyChooseheading: "Affordable Airport Taxi Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Airport cab pricing with transparent fare details and no hidden charges. Customers receive clear airport taxi fare information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Airport Cab Availability",
        WhyChoosedescription: "Our Pune Airport cab service operates 24 hours a day for early morning flights, late-night arrivals, emergency airport transfers, and business travel requirements."
      },
      {
        WhyChooseheading: "Clean & Comfortable AC Airport Taxis",
        WhyChoosedescription: "All airport taxis provided by Shivai Travels are fully air-conditioned, sanitized, and well maintained to provide comfortable travel experiences for passengers and families."
      },
      {
        WhyChooseheading: "One Way & Round Trip Airport Transfers",
        WhyChoosedescription: "Shivai Travels offers flexible airport transfer options including one-way airport drop, pickup service, round-trip airport travel, and customized travel plans."
      },
      {
        WhyChooseheading: "Wide Range of Airport Cab Vehicles",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for solo travelers, families, and corporate groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides airport pickup and drop services from homes, offices, hotels, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, and Pimpri Chinchwad."
      },
      {
        WhyChooseheading: "Professional Airport Transfer Drivers",
        WhyChoosedescription: "Our experienced drivers track flight schedules, provide punctual pickups, assist with luggage, and ensure smooth airport transportation for all passengers."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune Airport cab service?", answer: "Pune Airport cab service provides airport pickup and drop transportation for passengers traveling to and from Pune Airport." },
    { question: "Is Pune Airport cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 airport taxi service in Pune." },
    { question: "Which vehicles are available for Pune Airport cab booking?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers for airport transfers." },
    { question: "Can I book a one-way airport taxi in Pune?", answer: "Yes, customers can book one-way airport pickup or drop taxi services in Pune." },
    { question: "Do you provide airport pickup from Pune Airport?", answer: "Yes, Shivai Travels provides both airport pickup and airport drop services." },
    { question: "Are all airport taxis air-conditioned?", answer: "Yes, all airport taxis are fully air-conditioned and maintained for passenger comfort." },
    { question: "Can I book Pune Airport cab service online?", answer: "Yes, customers can easily book Pune Airport cab service online or through phone booking." },
    { question: "Do you provide airport taxis for family travel?", answer: "Yes, Shivai Travels provides comfortable airport taxis suitable for families and group travel." },
    { question: "Are airport cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent airport taxi pricing without hidden charges." },
    { question: "Is advance airport cab booking available?", answer: "Yes, advance booking is available and recommended for airport transfers and flight schedules." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Kunal Patwardhan",
      feedback:
        "Booked Pune Airport cab service with Shivai Travels. On-time pickup, clean car, and professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Radhika Mehta",
      feedback:
        "Excellent airport taxi service in Pune. Comfortable cab, affordable fare, and smooth airport transfer experience.",
      rating: 5
    }
  ];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport Cabs",
  "image": "https://shivaitravels.com/assets/images/pune-airport-cab.jpg",
  "description": "Book Pune airport cabs for reliable airport pickup and drop services. Shivai Travels offers affordable airport taxi booking, private airport cabs, sedan and luxury taxi options with 24x7 service for local and outstation travel.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹699",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-airport-cabs"
  }
};





  return (
    <div>

<Helmet>
  <title>Pune Airport Cabs | Airport Pickup & Drop Taxi Service | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune airport cabs for airport pickup and drop services. Affordable and reliable airport taxi booking with sedan, private, and luxury cabs available 24x7 in Pune."
  />

  <meta
    name="keywords"
    content="Pune airport cab, airport taxi pune, pune airport pickup drop, cab to pune airport, cab from pune airport, pune airport taxi booking, airport transfer pune, 24x7 airport cab pune, cheap airport cab pune, luxury airport cab pune, pune airport shuttle taxi, reliable airport taxi pune, private airport cab pune, pune airport cab fare, sedan airport cab pune, Pune to mumbai airport cab fare, Pune airport to shirdi distance taxi fare, Pune airport cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneairportcab;